module.exports = __webpack_public_path__ + "static/media/placeholder-store.f3f09f48.jpg";